import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Autocomplete,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Collapse,
  Typography,
  Button,
  FormGroup,
  Checkbox,
  Modal,
  Backdrop,
  FormHelperText,
} from "@mui/material";
import React, {
  ChangeEvent,
  FormEvent,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import currencies from "../../currencies.json";
import documents from "../../documents.json";
import states from "../../states.json";
import { Check, Clear, Close } from "@mui/icons-material";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import { MainFormState } from "../../models/MainFormState";
import Consent from "../Consent/Consent";
import { useAppDispatch } from "../../redux/hooks";
import { generateForm } from "../../redux/FormsAPI";
import { IFile } from "../../models/IFile";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useLocation, useHistory, Prompt } from "react-router-dom";
import { startLoading, stopLoading } from "../../redux/QuestionnaireSlice";
import { RootState } from "../../redux/store";
import { IState, ICountry } from "../../interfaces";
import theme, { red } from "../../theme";
import {
  removeFile,
  selectFiles,
  setFiles,
} from "../FileUploader/FileUploaderSlice";
import { useSelector } from "react-redux";
import { setErrMsg } from "../../redux/UserSlice";
import { modalStyle } from "../../Error";

const acceptedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx"];

interface MainFormProps {
  countries: ICountry[];
  countriesLoading: boolean;
  countriesError: boolean;
}

export default function MainForm({ countries, countriesLoading, countriesError }: MainFormProps) {
  const getKey = useKeyDispensor();

  const dispatch = useAppDispatch();

  const files = useSelector(selectFiles);

  const { register, handleSubmit } = useForm({
    mode: "onBlur",
  });

  const initialState = {
    name: "",
    lastName: "",
    gender: "",
    birthDate: "",
    otherName: "",
    otherLastName: "",
    otherBirthDate: null,
    state: null,
    postalCode: "",
    countryOfBirth: null,
    cityOfBirth: "",
    addressOne: "",
    city: "",
    country: "",
    homePhone: "",
    cellPhone: "",
    email: "",
    isContact: false,
    contactName: "",
    contactLastName: "",
    relationship: "",
    contactCountry: null,
    contactAddress: "",
    contactCity: "",
    contactState: null,
    contactPostalCode: "",
    contactHomePhone: "",
    contactCellPhone: "",
    contactEmail: "",
    isCompensated: false,
    fundCompensated: "",
    currency: "",
    isIncomeBelow: true,
    isAssetsBelow: true,
    document: "",
    documentType: "",
    files: [],
    isRecentlyCompensated: null,
    bankName: "",
    bankAddress: "",
    accountType: null,
    accountCurrency: null,
    ibanNumber: "",
    swiftCode: "",
    intermediaryBankName: "",
    intermediaryBankNumber: "",
    intermediaryBankSwiftCode: "",
    isOpen: false,
    isConsent1: null,
    isConsent2: null,
    errors: [],
  };

  const [state, setState] = useState<MainFormState>(initialState);
  const [disabled, setDisabled] = useState(false);

  const submit = async (data: any) => {
    setDisabled(true);
    dispatch(startLoading());
    console.log("submit");

    const info = {
      ...state,
      countryOfBirth: state.countryOfBirth!.name,
      contactCountry: state.contactCountry ? state.contactCountry.name : "",
      birthDate: state.birthDate
        ? state.birthDate.toLocaleString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })
        : "",
      state: state.state ? state.state.code : "",
      contactState: state.contactState ? state.contactState.code : "",
    };
    console.log(info);
    //@ts-ignore
    delete info.files;
    //@ts-ignore
    delete info.errors;
    //@ts-ignore
    delete info.isOpen;
    //@ts-ignore
    delete info.isConsent1;
    //@ts-ignore
    delete info.isConsent2;

    console.log(files[0].file);
    try {
      const response = await dispatch(
        generateForm({
          info: info,
          files: files[0].file,
          formType: "application",
        })
      );

      if (
        response &&
        response.payload &&
        response.payload.success === false &&
        response.payload.msg
      ) {
        dispatch(setErrMsg(response.payload.msg));
        setDisabled(false);
      } else if (
        response &&
        response.payload &&
        response.payload.data &&
        response.payload.data?.url
      ) {
        const { envelopeId, accessToken, url, imgName } = response.payload.data;

        localStorage.setItem("envelopeId", envelopeId);
        localStorage.setItem("imgName", imgName);
        localStorage.setItem("accessToken", accessToken);

        window.location.replace(url);
      } else {
        // Check if there's a backend error message
        let errorMessage = "Something went wrong.";
        if (
          response?.payload?.msg &&
          response?.payload?.success === false
        ) {
          errorMessage = response.payload.msg;
        } else if (
          response?.payload?.data?.msg &&
          response?.payload?.data?.success === false
        ) {
          errorMessage = response.payload.data.msg;
        } else if (!response) {
          errorMessage = "No response received from the server.";
        } else if (!response.payload) {
          errorMessage = "Response payload is missing.";
        } else if (!response.payload.data) {
          errorMessage = "Response payload data is missing.";
        } else if (!response.payload.data.url) {
          errorMessage = "URL is missing in the response payload data.";
        }

        console.error(errorMessage);
        dispatch(setErrMsg(errorMessage));
        setDisabled(false);
      }
    } catch (error) {
      console.error("Error occurred while generating the form:", error);
      dispatch(setErrMsg("An unexpected error occurred. Please try again later."));
      setDisabled(false);
    } finally {
      dispatch(stopLoading());
    }

    // const response = await dispatch(
    //   generateForm({
    //     info: info,
    //     files: files[0].file,
    //     formType: "application",
    //   })
    // );


    // if (
    //   response &&
    //   response.payload &&
    //   response.payload.data &&
    //   response.payload.data?.url
    // ) {
    //   const { envelopeId, accessToken, url, imgName } = response.payload.data;

    //   localStorage.setItem("envelopeId", envelopeId);

    //   localStorage.setItem("imgName", imgName);

    //   localStorage.setItem("accessToken", accessToken);

    //   window.location.replace(url);
    // } else {
    //   dispatch(setErrMsg("Something went wrong."));
    //   setDisabled(false);
    // }

    // dispatch(stopLoading());
  };

  const handleTextInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    let test = /^[a-zA-Z ]*$/;
    sessionStorage.isFormDirty = "true";

    if (!test.test(event.target.value)) return;

    if (
      event.target.name === "otherName" ||
      event.target.name === "otherLastName"
    ) {
      setState((prevState) => {
        if (event.target.value.length >= 50) return prevState;

        const errors = prevState.errors.filter((error) => error !== "other");

        return {
          ...prevState,
          errors,
          [event.target.name]: event.target.value,
        };
      });

      return;
    }

    handleRemoveError(
      state.errors.findIndex((error) => error === event.target.name)
    );

    if (
      (event.target.name === "name" ||
        event.target.name === "lastName" ||
        event.target.name === "city" ||
        event.target.name === "state" ||
        event.target.name === "contactName" ||
        event.target.name === "contactState" ||
        event.target.name === "contactCity" ||
        event.target.name === "contactLastName") &&
      event.target.value.length >= 50
    )
      return;

    if (
      event.target.name === "relationship" &&
      event.target.value.length >= 200
    )
      return;
    if (
      (event.target.name === "bankName" ||
        event.target.name === " intermediaryBankName") &&
      event.target.value.length >= 35
    )
      return;

    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleAlphanumInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.name);
    let test = /^[a-zA-Z0-9 ]*$/;
    if (
      event.target.name === "addressOne" ||
      event.target.name === "contactAddress"
    ) {
      test = /^[a-zA-Z0-9., ]*$/;
    }
    if (
      event.target.name === "postalCode" ||
      event.target.name === "contactPostalCode"
    ) {
      test = /^[a-zA-Z0-9- ]*$/;
    }
    if (!test.test(event.target.value)) return;

    handleRemoveError(
      state.errors.findIndex((error) => error === event.target.name)
    );
    if (
      event.target.name === "ibanNumber" ||
      event.target.name === "intermediaryBankNumber"
    ) {
      if (state.isRecentlyCompensated && event.target.value.length > 4) {
        return;
      }
      if (!state.isRecentlyCompensated && event.target.value.length > 33) {
        return;
      }
    }
    if (
      (event.target.name === "swiftCode" ||
        event.target.name === "intermediaryBankSwiftCode") &&
      event.target.value.length > 11
    ) {
      return;
    }
    if (event.target.name === "fundCompensated" && event.target.value.length >= 100) return;
    if (event.target.value.length >= 255) return;
    if (
      (event.target.name === "postalCode" ||
        event.target.name === "contactPostalCode") &&
      event.target.value.length >= 12
    )
      return;
    if (event.target.name === "bankAddress" && event.target.value.length >= 35)
      return;

    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleNumberInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!/^[0-9]*$/.test(event.target.value)) return;

    if (
      event.target.name === "homePhone" ||
      event.target.name === "cellPhone"
    ) {
      setState((prevState) => {
        if (event.target.value.length > 18) return prevState;

        const errors = prevState.errors.filter(
          (error) => error !== "phone" && error !== event.target.name
        );

        return {
          ...prevState,
          errors,
          [event.target.name]: event.target.value,
        };
      });

      return;
    } else {
      handleRemoveError(
        state.errors.findIndex((error) => error === event.target.name)
      );
    }

    if (
      event.target.name === "contactHomePhone" ||
      event.target.name === "contactCellPhone"
    ) {
      setState((prevState) => {
        if (event.target.value.length > 18) return prevState;

        const errors = prevState.errors.filter(
          (error) => error !== "contactPhone" && error !== event.target.name
        );

        return {
          ...prevState,
          errors,
          [event.target.name]: event.target.value,
        };
      });

      return;
    } else {
      handleRemoveError(
        state.errors.findIndex((error) => error === event.target.name)
      );
    }

    if (
      (event.target.name === "cellPhone" ||
        event.target.name === "homePhone" ||
        event.target.name === "contactCellPhone" ||
        event.target.name === "contactHomePhone") &&
      event.target.value.length >= 15
    )
      return;

    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length >= 255) return;

    handleRemoveError(
      state.errors.findIndex((error) => error === event.target.name)
    );

    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleChangeCountry = (
    _: SyntheticEvent,
    value: { name: string; eligible: boolean } | null
  ) => {
    return setState((prevState) => {
      const errors = prevState.errors.filter(
        (error) => error !== "state" && error !== "countryOfBirth"
      );
      return {
        ...prevState,
        countryOfBirth: value ? value : null,
        state: null,
        errors,
      };
    });
  };

  const handleChangeCountryOfResidence = (
    _: SyntheticEvent,
    value: string | null
  ) => {
    return setState((prevState) => {
      const errors = prevState.errors.filter(
        (error) => error !== "state" && error !== "country"
      );
      return {
        ...prevState,
        country: value ? value : null,
        state: null,
        errors,
      };
    });
  };

  const handleChangeContactCountry = (
    _: SyntheticEvent,
    value: { name: string; eligible: boolean } | null
  ) => {
    return setState((prevState) => {
      const errors = prevState.errors.filter(
        (error) => error !== "contactState" && error !== "contactCountry"
      );
      return {
        ...prevState,
        contactCountry: value ? value : null,
        contactState: null,
        errors,
      };
    });
  };

  const handleStateChange = (
    _: SyntheticEvent,
    value: { name: string; code: string; countryCode: string } | null
  ) => {
    handleRemoveError(state.errors.findIndex((error) => error === "state"));

    setState({
      ...state,
      state: value ? value : null,
    });
  };

  const handleContactStateChange = (
    _: SyntheticEvent,
    value: { name: string; code: string; countryCode: string } | null
  ) => {
    handleRemoveError(
      state.errors.findIndex((error) => error === "contactState")
    );

    setState({
      ...state,
      contactState: value ? value : null,
    });
  };

  const handleGenderChange = (event: SelectChangeEvent<number>) => {
    handleRemoveError(state.errors.findIndex((error) => error === "gender"));

    setState({ ...state, gender: event.target.value as number });
  };

  const handleCurrencyChange = (
    _: SyntheticEvent,
    value: {
      name: string;
      symbol: string;
      symbolNative: string;
      decimalDigits: number;
      rounding: number;
      code: string;
      namePlural: string;
    } | null
  ) => {
    handleRemoveError(state.errors.findIndex((error) => error === "currency"));

    setState({ ...state, currency: value ? value.code : "" });
  };

  const handleDateChange = (date: Date | null) => {
    if (!date || isNaN(date.getTime())) {
      if (!state.errors.includes("birthDate"))
        return setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, "birthDate"],
        }));

      return setState({
        ...state,
        birthDate: "",
      });
    }

    if (
      date.getTime() <= new Date("1946-02-09").getTime() &&
      new Date().getFullYear() - date.getFullYear() < 115
    ) {
      handleRemoveError(
        state.errors.findIndex((error) => error === "birthDate")
      );
    } else {
      console.log(date.toLocaleString("en-GB", { month: "short" }));
      if (!state.errors.includes("birthDate"))
        return setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, "birthDate"],
          birthDate: date.toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          }),
        }));
    }

    setState({
      ...state,
      birthDate: date.toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    });
  };

  const handleOtherDateChange = (date: Date | null) => {
    if (!date || isNaN(date.getTime())) {
      if (!state.errors.includes("otherBirthDate"))
        return setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, "otherBirthDate"],
        }));

      return setState({
        ...state,
        otherBirthDate: "",
      });
    }
    console.log(date.getFullYear());
    console.log(new Date().getFullYear());
    if (
      date.getTime() <= new Date("1946-02-09").getTime() &&
      new Date().getFullYear() - date.getFullYear() < 115
    ) {
      handleRemoveError(
        state.errors.findIndex((error) => error === "otherBirthDate")
      );
    } else {
      if (!state.errors.includes("otherBirthDate"))
        return setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, "otherBirthDate"],
          birthDate: date,
        }));
    }

    setState({
      ...state,
      otherBirthDate: date,
    });
  };

  const handleRadioChange = ({
    currentTarget,
  }: ChangeEvent<HTMLInputElement>) => {
    const value = currentTarget.value === "true" ? true : false;

    if (currentTarget.name === "isContact" && !value) {
      return setState((prevState) => {
        const errors = prevState.errors.filter(
          (error) => !error.includes("contact") && error !== "relationship"
        );

        return {
          ...prevState,
          contactName: "",
          contactLastName: "",
          relationship: "",
          contactAddress: "",
          contactCity: "",
          contactState: null,
          contactPostalCode: "",
          contactHomePhone: "",
          contactCellPhone: "",
          contactEmail: "",
          contactCountry: null,
          errors,
          [currentTarget.name]: value,
        };
      });
    }

    if (currentTarget.name === "isRecentlyCompensated") {
      return setState((prevState) => {
        const errors = prevState.errors.filter(
          (error) =>
            !error.includes("bank") &&
            !error.includes("account") &&
            error !== "ibanNumber" &&
            error !== "swiftCode" &&
            error !== "isRecentlyCompensated"
        );

        return {
          ...prevState,
          bankName: "",
          bankAddress: "",
          accountType: null,
          accountCurrency: null,
          ibanNumber: "",
          swiftCode: "",
          intermediaryBankName: "",
          intermediaryBankNumber: "",
          intermediaryBankSwiftCode: "",
          errors,
          [currentTarget.name]: value,
        };
      });
    }

    setState({ ...state, [currentTarget.name]: value });
  };

  const handleChangeDocument = (event: SelectChangeEvent<string>) => {
    if (event.target.value !== "Other")
      return setState((prevState) => {
        const errors = prevState.errors.filter(
          (error) => !error.includes("document")
        );

        return {
          ...prevState,
          errors,
          documentType: "",
          document: event.target.value,
        };
      });

    handleRemoveError(state.errors.findIndex((error) => error === "document"));

    setState({ ...state, document: event.target.value });
  };

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;
    console.log(event.target.value);

    const arr = Array.from(event.target.files);

    addFiles(arr);

    event.target.value = "";
  };

  const addFiles = async (newFiles: File[]) => {
    console.log(newFiles);
    const withKey: IFile[] = newFiles.map((file) => {
      const [name, extension] = splitName(file.name);

      return {
        file,
        name,
        extension,
        supported: acceptedExtensions.includes(extension.toLocaleLowerCase()),
        empty: file.size === 0,
        key: getKey(),
      };
    });

    const isUnsupported = withKey.find((file) => !file.supported);

    if (isUnsupported) {
      if (!state.errors.find((error) => error === "files")) {
        setState({
          ...state,
          errors: [...state.errors, "files"],
        });
      }
      dispatch(setFiles(withKey));
      setState((prevState) => ({
        ...prevState,
        files: [...withKey],
      }));
    } else {
      handleRemoveError(state.errors.findIndex((error) => error === "files"));
      dispatch(setFiles(withKey));
      setState((prevState) => ({
        ...prevState,
        files: [...withKey],
      }));
    }
  };

  const splitName = (name: string) => {
    const split = name.split(".");
    const extension = split.length > 1 ? `.${split.pop()}` : "";
    const nameWithoutExtension = split.join(".");
    return [nameWithoutExtension, extension];
  };

  const handleRemoveError = (index: number) => {
    if (index === -1) return;

    setState((prevState) => {
      prevState.errors.splice(index, 1);
      return {
        ...prevState,
        errors: prevState.errors,
      };
    });
  };

  const handleCheckboxChange = (event: ChangeEvent<any>) => {
    handleRemoveError(
      state.errors.findIndex((error) => error === event.target.name)
    );

    if ((state as any)[event.target.name] === event.target.value)
      return setState({ ...state, [event.target.name]: null });

    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleOpenModal = (event: FormEvent) => {
    event.preventDefault();

    let isErrors = false;

    let element: string | null = null;
    console.log(state);
    for (const field in state) {
      if (state.errors.includes(field)) {
        console.log(state.errors);

        isErrors = true;

        if (!element) element = field;
        console.log(element);

        continue;
      }

      if (field === "documentType") {
        if (state.document === "Other" && !state.documentType) {
          isErrors = true;

          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, field],
          }));

          if (!element) element = field;

          continue;
        } else continue;
      }

      if (
        field === "isRecentlyCompensated" &&
        state.isRecentlyCompensated === null &&
        !state.errors.includes("isRecentlyCompensated")
      ) {
        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));
  
        continue;
      }

      if (field.includes("is")) continue;

      if (
        !state.isContact &&
        (field.includes("contact") || field.includes("relationship"))
      )
        continue;

      if (
        (field === "homePhone" ||
          field === "cellPhone" ||
          field === "contactHomePhone" ||
          field === "contactCellPhone") &&
        state[field].length
      ) {
        if (state[field].length < 8) {
          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, field],
          }));
          isErrors = true;
        }
      }

      if (field === "fundCompensated" && !state.isCompensated) continue;
      if (
        field === "intermediaryBankNumber" &&
        state.intermediaryBankNumber &&
        state.intermediaryBankNumber.length < 11
      ) {
        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));
      }

      if (
        field === "intermediaryBankSwiftCode" &&
        state.intermediaryBankSwiftCode &&
        state.intermediaryBankSwiftCode.length < 8
      ) {
        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));
      }
      if (
        field === "otherName" ||
        field === "otherLastName" ||
        field === "cellPhone" ||
        field === "contactCellPhone" ||
        field === "intermediaryBankName" ||
        field === "intermediaryBankNumber" ||
        field === "intermediaryBankSwiftCode" ||
        field === "state" ||
        field === "contactState"
      )
        continue;

      if (field === "state") {
        if (
          state.country &&
          (state.country === "United States" || state.country === "Canada") &&
          !state.state
        ) {
          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, "state"],
          }));

          if (!element) element = field;

          continue;
        } else continue;
      }

      if (field === "contactState") {
        if (
          state.contactCountry &&
          (state.contactCountry.name === "United States" ||
            state.contactCountry.name === "Canada") &&
          !state.contactState
        ) {
          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, "contactState"],
          }));

          if (!element) element = field;

          continue;
        } else continue;
      }
if (field === "homePhone") {
  const homeValid = state.homePhone && state.homePhone.length >= 8;
  const cellValid = state.cellPhone && state.cellPhone.length >= 8;

  if ((!state.homePhone && !state.cellPhone) || (!homeValid && !cellValid)) {
    if (!state.errors.includes("phone")) {
      setState((prevState) => ({
        ...prevState,
        errors: [...prevState.errors, "phone"],
      }));
    }
       isErrors = true;
    if (!element) element = field;
    continue;
  } else {
    // Remove "phone" error if at least one is valid
    if (homeValid || cellValid) {
      handleRemoveError(state.errors.findIndex((error) => error === "phone"));
    }
    continue;
  }
}
if (field === "contactHomePhone" && state.isContact) {
  const contactHomeValid =
    state.contactHomePhone && state.contactHomePhone.length >= 8;
  const contactCellValid =
    state.contactCellPhone && state.contactCellPhone.length >= 8;

  if (
    (!state.contactHomePhone && !state.contactCellPhone) ||
    (!contactHomeValid && !contactCellValid)
  ) {
    if (!state.errors.includes("contactPhone")) {
      setState((prevState) => ({
        ...prevState,
        errors: [...prevState.errors, "contactPhone"],
      }));
    }
       isErrors = true; 
    if (!element) element = field;
    continue;
  } else {
    // Remove "contactPhone" error if at least one is valid
    if (contactHomeValid || contactCellValid) {
      handleRemoveError(state.errors.findIndex((error) => error === "contactPhone"));
    }
    continue;
  }
}

      if (
        (field === "email" || field === "contactEmail") &&
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[A-Za-z]+$/.test(
          field === "email" ? state.email : state.contactEmail
        )
      ) {
        if (field === "contactEmail" && !state.contactEmail) continue;

        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));

        if (!element) element = field;

        continue;
      }

      if (field === "files") {
        if (!files.length || files.find((file) => !file.supported)) {
          isErrors = true;
          if (!state.errors.includes("files")) {
            setState((prevState) => ({
              ...prevState,
              errors: [...prevState.errors, field],
            }));
          }

          if (!element) element = field;

          continue;
        } else {
          continue;
        }
      }
      if (field === "otherBirthDate") {
        console.log(state.otherBirthDate);
        if (
          state.otherBirthDate &&
          new Date(state.otherBirthDate).getTime() >=
          new Date("1946-02-09").getTime()
        ) {
          isErrors = true;
          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, field],
          }));
          console.log("line973");
          if (!element) element = field;
          continue;
        }
        continue;
      }

      if (
        state.isRecentlyCompensated === false &&
        (field.includes("bank") ||
          field.includes("account") ||
          field === "swiftCode") &&
        !state[field as "swiftCode"]
      ) {
        if (!state.errors.includes(field))
          setState((prevState) => ({
            ...prevState,
            errors: [...prevState.errors, field],
          }));

        if (!element) element = field;

        continue;
      }

      if (
        state.isRecentlyCompensated &&
        (field.includes("bank") ||
          field.includes("account") ||
          field === "swiftCode")
      )
        continue;

      if (
        field === "ibanNumber" &&
        !state.isRecentlyCompensated &&
        state.ibanNumber.length < 11
      ) {
        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));
      }

      if (field === "swiftCode" && state.swiftCode.length < 8) {
        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));
      }
      if (!(state as any)[field]) {
        isErrors = true;

        setState((prevState) => ({
          ...prevState,
          errors: [...prevState.errors, field],
        }));

        if (!element) element = field;
      }
    }

if (isErrors) {
  if (element) {
    // Try to scroll to the error field
    let el = document.getElementsByClassName(element);
    if (el.length === 0) {
      const nodeList = document.getElementsByName(element);
      el = Array.from(nodeList) as unknown as HTMLCollectionOf<Element>;
    }
    if (el.length > 0) {
      el[0].scrollIntoView();
    }
  }
  // Do NOT open the modal
  return;
}

// No errors, open the modal
setState({ ...state, isOpen: true });
    setState({ ...state, isOpen: true });
  };

  const handleCloseModal = () => {
    setState({ ...state, isOpen: false });
  };

  return (
    <Box
      sx={{
        [theme.breakpoints.up("xl")]: {
          marginTop: "13em",
          marginBottom: "7em",
        },
        [theme.breakpoints.up("lg")]: {
          marginTop: "10em",
          marginBottom: "7em",
        },

        [theme.breakpoints.up("xs")]: {
          marginTop: "9em",
          marginBottom: "9em",
        },
      }}
    >
      <Prompt
        when={JSON.stringify(state) !== JSON.stringify(initialState)}
        message={
          "You have unsaved changes. Are you sure you want to leave the page?"
        }
      />
      <Card variant="outlined">
        <CardHeader
          title="Application for Emergency Assistance Program"
          subheader="If you have trouble completing the form, please contact EAPROW@claimscon.org."
        />
        <CardContent>
          <form onSubmit={handleOpenModal}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <TextField
                  label={
                    <Typography>
                      First Name{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="name"
                  value={state.name}
                  autoComplete="given-name"
                  onChange={handleTextInputChange}
                  error={state.errors.includes("name")}
                  helperText={
                    state.errors.includes("name")
                      ? "Please fill in your name"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label={
                    <Typography>
                      Last Name{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="lastName"
                  value={state.lastName}
                  autoComplete="family-name"
                  onChange={handleTextInputChange}
                  error={state.errors.includes("lastName")}
                  helperText={
                    state.errors.includes("lastName")
                      ? "Please fill in your last name"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="gender">
                    <Typography>
                      Select Gender{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="gender"
                    fullWidth
                    value={state.gender ? state.gender : ""}
                    label={
                      <Typography>
                        Select Gender{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    onChange={handleGenderChange}
                    name="gender"
                    error={state.errors.includes("gender")}
                  >
                    <MenuItem value={1}>Female</MenuItem>
                    <MenuItem value={2}>Male</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  maxDate={new Date("1946-02-08")}
                  label={
                    <Typography>
                      Date of Birth DD/MM/YYYY{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  value={state.birthDate ? new Date(state.birthDate) : null}
                  format="dd/MM/yyyy"
                  onChange={handleDateChange}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: state.errors.includes("birthDate"),
                      name: "birthDate",

                      helperText: state.errors.includes("birthDate")
                        ? state.birthDate &&
                          new Date(state.birthDate).getTime() >=
                          new Date("1946-02-09").getTime()
                          ? "Date must be before February 9th 1946"
                          : state.birthDate &&
                            new Date().getFullYear() -
                            new Date(state.birthDate).getFullYear() >=
                            115
                            ? "The age cannot be more than 115 years"
                            : "Please enter your date of birth"
                        : "",
                    },
                  }}
                ></DatePicker>

                {/*               
                   <DatePicker
                    maxDate={new Date("1946-02-08")
                      .toLocaleDateString("en-CA", {
                        timeZone: "Asia/Jerusalem",
                      })
                      .replace(/\D/g, "/")}
                    margin="normal"
                    format="MM/dd/yyyy"
                    fullWidth
                    label={
                      <Typography>
                        Date of birth MM/DD/YYYY{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    name="birthDate"
                    value={
                      state.birthDate
                        ? new Date(state.birthDate)
                            .toLocaleDateString("en-CA", {
                              timeZone: "Asia/Jerusalem",
                            })
                            .replace(/\D/g, "/")
                        : null
                    }
                    onChange={handleDateChange}
                    okLabel={<Check />}
                    cancelLabel={<Clear />}
                    type="tel"
                    error={state.errors.includes("birthDate")}
                    helperText={
                      state.errors.includes("birthDate")
                        ? state.birthDate &&
                          new Date(state.birthDate).getTime() >=
                            new Date("1946-02-09").getTime()
                          ? "Date must be before February 9th 1946"
                          : state.birthDate &&
                            new Date().getFullYear() -
                              new Date(state.birthDate).getFullYear() >=
                              130
                          ? "Date too early"
                          : "Please enter your date of birth"
                        : ""
                    }
                    inputVariant="outlined"
                  />  */}
              </Grid>
              <Grid item xs={12} sm={6} className="countryOfBirth">
                <Autocomplete
                  options={countries}
                  getOptionLabel={(option) => option.name}
                  onChange={handleChangeCountry}
                  value={state.countryOfBirth ? state.countryOfBirth : null}
                  loading={countriesLoading}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <Typography>
                          Country of Birth{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      error={state.errors.includes("countryOfBirth") || countriesError}
                      helperText={
                        countriesError
                          ? "Failed to load country list. Please refresh the page."
                          : state.errors.includes("countryOfBirth")
                          ? "Please select a country"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={
                    <Typography>
                      City of Birth{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="cityOfBirth"
                  value={state.cityOfBirth}
                  autoComplete="address-level2"
                  onChange={handleTextInputChange}
                  error={state.errors.includes("cityOfBirth")}
                  helperText={
                    state.errors.includes("cityOfBirth")
                      ? "Please enter your city of birth"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <Typography>
                  If you apply for compensation with a name or date of birth
                  different from the ones provided above, please state it below.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label={<Typography>Other First Name</Typography>}
                  fullWidth
                  name="otherName"
                  value={state.otherName}
                  onChange={handleTextInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label={<Typography>Other Last Name</Typography>}
                  fullWidth
                  name="otherLastName"
                  value={state.otherLastName}
                  onChange={handleTextInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <DatePicker
                  format="dd/MM/yyyy"
                  label={
                    <Typography>Other Date of Birth DD/MM/YYYY </Typography>
                  }
                  maxDate={new Date("1946-02-08")}
                  value={
                    state.otherBirthDate ? new Date(state.otherBirthDate) : null
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: state.errors.includes("otherBirthDate"),
                      name: "otherBirthDate",
                      helperText: state.errors.includes("otherBirthDate")
                        ? state.otherBirthDate &&
                          new Date(state.otherBirthDate).getTime() >=
                          new Date("1946-02-09").getTime()
                          ? "Date must be before February 9th 1946"
                          : state.otherBirthDate &&
                            new Date().getFullYear() -
                            new Date(state.otherBirthDate).getFullYear() >=
                            115
                            ? "The age cannot be more than 115 years"
                            : "Please enter your date of birth"
                        : "",
                    },
                  }}
                  onChange={handleOtherDateChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label={
                    <Typography>
                      Address{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="addressOne"
                  value={state.addressOne}
                  autoComplete="address-line1"
                  onChange={handleAlphanumInputChange}
                  error={state.errors.includes("addressOne")}
                  helperText={
                    state.errors.includes("addressOne")
                      ? "Please enter your address"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label={
                    <Typography>
                      City{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="city"
                  value={state.city}
                  autoComplete="address-level2"
                  onChange={handleTextInputChange}
                  error={state.errors.includes("city")}
                  helperText={
                    state.errors.includes("city")
                      ? "Please enter your city"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label={
                    <Typography>
                      Postal Code{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="postalCode"
                  value={state.postalCode}
                  autoComplete="postal-code"
                  onChange={handleAlphanumInputChange}
                  error={state.errors.includes("postalCode")}
                  helperText={
                    state.errors.includes("postalCode")
                      ? "Please enter your Postal code"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} className="country">
                <Autocomplete
                  options={countries.map((country) => country.name)}
                  onChange={handleChangeCountryOfResidence}
                  value={state.country ? state.country : null}
                  loading={countriesLoading}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <Typography>
                          Country of Residence{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      error={state.errors.includes("country") || countriesError}
                      helperText={
                        countriesError
                          ? "Failed to load country list. Please refresh the page."
                          : state.errors.includes("country")
                          ? "Please select a country"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={
                    !state.country
                      ? []
                      : state.country === "Canada"
                        ? states.filter((_state) => _state.countryCode === "CA")
                        : states.filter((_state) => _state.countryCode === "US")
                  }
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    value.name ? option.name === value.name : option.name === ""
                  }
                  onChange={handleStateChange}
                  value={state.state ? state.state : null}
                  autoHighlight
                  disabled={
                    !state.country ||
                    (state.country !== "Canada" &&
                      state.country !== "United States")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      error={state.errors.includes("state")}
                      helperText={
                        state.errors.includes("state")
                          ? "Please select a state"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label={
                    <Typography>
                      Home Phone Number{" "}
                      {!state.cellPhone ? (
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      ) : null}
                    </Typography>
                  }
                  fullWidth
                  name="homePhone"
                  value={state.homePhone}
                  autoComplete="tel"
                  onChange={handleNumberInputChange}
                  InputProps={{ startAdornment: "+" }}
                  error={
                    state.errors.includes("phone") ||
                    state.errors.includes("homePhone")
                  }
                  helperText={
                    state.errors.includes("phone")
                      ? "Please enter at least one phone number"
                      : state.errors.includes("homePhone")
                        ? "Must be at least 8 digits"
                        : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label={
                    <Typography>
                      Cell Phone Number{" "}
                      {!state.homePhone ? (
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      ) : null}
                    </Typography>
                  }
                  fullWidth
                  name="cellPhone"
                  value={state.cellPhone}
                  autoComplete="tel"
                  onChange={handleNumberInputChange}
                  InputProps={{ startAdornment: "+" }}
                  error={
                    state.errors.includes("phone") ||
                    state.errors.includes("cellPhone")
                  }
                  helperText={
                    state.errors.includes("phone")
                      ? "Please enter at least one phone number"
                      : state.errors.includes("cellPhone")
                        ? "Must be at least 8 digits"
                        : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label={
                    <Typography>
                      Email{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  }
                  fullWidth
                  name="email"
                  value={state.email}
                  autoComplete="email"
                  onChange={handleEmailChange}
                  error={state.errors.includes("email")}
                  helperText={
                    state.errors.includes("email")
                      ? "Please enter a valid email"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl>
                  <FormLabel>
                    Is there anyone whom you would like to allow us to speak
                    with or write to regarding your participation in this
                    program?
                  </FormLabel>

                  <RadioGroup
                    row
                    name="isContact"
                    value={state.isContact}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Collapse
                in={state.isContact}
                sx={{ width: "100%", paddingLeft: 3 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          Contact First Name{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="contactName"
                      value={state.contactName}
                      onChange={handleTextInputChange}
                      error={state.errors.includes("contactName")}
                      helperText={
                        state.errors.includes("contactName")
                          ? "Please enter the contact's name"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          Contact Last Name{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="contactLastName"
                      value={state.contactLastName}
                      onChange={handleTextInputChange}
                      error={state.errors.includes("contactLastName")}
                      helperText={
                        state.errors.includes("contactLastName")
                          ? "Please enter the contact's last name"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          Relationship to you{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="relationship"
                      value={state.relationship}
                      onChange={handleTextInputChange}
                      error={state.errors.includes("relationship")}
                      helperText={
                        state.errors.includes("relationship")
                          ? "Please specify your relation to the contact"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={
                        <Typography>
                          Contact Address{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="contactAddress"
                      value={state.contactAddress}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("contactAddress")}
                      helperText={
                        state.errors.includes("contactAddress")
                          ? "Please enter your contact's address"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={
                        <Typography>
                          Contact City{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="contactCity"
                      value={state.contactCity}
                      onChange={handleTextInputChange}
                      error={state.errors.includes("contactCity")}
                      helperText={
                        state.errors.includes("contactCity")
                          ? "Please enter your contact's city"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={
                        <Typography>
                          Contact Postal Code{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="contactPostalCode"
                      value={state.contactPostalCode}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("contactPostalCode")}
                      helperText={
                        state.errors.includes("contactPostalCode")
                          ? "Please enter your contat's Postal code"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={countries}
                      getOptionLabel={(option) => option.name}
                      onChange={handleChangeContactCountry}
                      value={state.contactCountry ? state.contactCountry : null}
                      isOptionEqualToValue={(option, value) =>
                        value.name
                          ? option.name === value.name
                          : option.name === ""
                      }
                      loading={countriesLoading}
                      autoHighlight
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <Typography>
                              Contact Country{" "}
                              <Typography color="red" component="span">
                                *
                              </Typography>
                            </Typography>
                          }
                          error={state.errors.includes("contactCountry") || countriesError}
                          helperText={
                            countriesError
                              ? "Failed to load country list. Please refresh the page."
                              : state.errors.includes("contactCountry")
                              ? "Please enter your contat's country"
                              : ""
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={
                        !state.contactCountry
                          ? []
                          : state.contactCountry.name === "Canada"
                            ? states.filter(
                              (_state) => _state.countryCode === "CA"
                            )
                            : states.filter(
                              (_state) => _state.countryCode === "US"
                            )
                      }
                      getOptionLabel={(option) => option.name}
                      onChange={handleContactStateChange}
                      value={{
                        name: state.contactState ? state.contactState.name : "",
                        code: state.contactState ? state.contactState.code : "",
                        countryCode: state.contactState
                          ? state.contactState.countryCode
                          : "",
                      }}
                      autoHighlight
                      disabled={
                        !state.contactCountry ||
                        (state.contactCountry.name !== "Canada" &&
                          state.contactCountry.name !== "United States")
                      }
                      isOptionEqualToValue={(option, value) =>
                        value.name
                          ? option.name === value.name
                          : option.name === ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Contact State"
                          error={state.errors.includes("contactState")}
                          helperText={
                            state.errors.includes("contactState")
                              ? "Please select a state"
                              : ""
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          Contact Home Phone Number{" "}
                          {!state.contactCellPhone ? (
                            <Typography color="red" component="span">
                              *
                            </Typography>
                          ) : null}
                        </Typography>
                      }
                      fullWidth
                      name="contactHomePhone"
                      InputProps={{ startAdornment: "+" }}
                      value={state.contactHomePhone}
                      onChange={handleNumberInputChange}
                      error={
                        state.errors.includes("contactPhone") ||
                        state.errors.includes("contactHomePhone")
                      }
                      helperText={
                        state.errors.includes("contactPhone")
                          ? "Please enter at least one phone number"
                          : state.errors.includes("contactHomePhone")
                            ? "Must be at least 8 digits"
                            : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          Contact Cell Phone Number{" "}
                          {!state.contactHomePhone ? (
                            <Typography color="red" component="span">
                              *
                            </Typography>
                          ) : null}
                        </Typography>
                      }
                      fullWidth
                      name="contactCellPhone"
                      InputProps={{ startAdornment: "+" }}
                      value={state.contactCellPhone}
                      onChange={handleNumberInputChange}
                      error={
                        state.errors.includes("contactPhone") ||
                        state.errors.includes("contactCellPhone")
                      }
                      helperText={
                        state.errors.includes("contactPhone")
                          ? "Please enter at least one phone number"
                          : state.errors.includes("contactCellPhone")
                            ? "Must be at least 8 digits"
                            : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Contact Email"
                      fullWidth
                      name="contactEmail"
                      value={state.contactEmail}
                      onChange={handleEmailChange}
                      error={state.errors.includes("contactEmail")}
                      helperText={
                        state.errors.includes("contactEmail")
                          ? "Please enter a valid email"
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </Collapse>

              <Grid item xs={12} sm={12}>
                <FormControl>
                  <FormLabel>
                    Have you ever received Claims Conference compensation, such
                    as Article 2 or Hardship Fund?
                  </FormLabel>

                  <RadioGroup
                    row
                    name="isCompensated"
                    value={state.isCompensated}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Collapse
                in={state.isCompensated === true}
                sx={{ width: "100%", paddingLeft: 3 }}
              >
                <Grid item xs={12}>
                  <TextField
                    label={
                      <Typography>
                        Fund Name{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    fullWidth
                    placeholder={""}
                    name="fundCompensated"
                    value={state.fundCompensated}
                    onChange={handleAlphanumInputChange}
                    error={state.errors.includes("fundCompensated")}
                    helperText={
                      state.errors.includes("fundCompensated")
                        ? "Please enter the name of the Claims Conference fund from which you have received compensation"
                        : ""
                    }
                  />
                </Grid>
              </Collapse>
              <Grid item xs={12} className="currency">
                <Typography variant="body1">
                  You must meet specific financial criteria to qualify for this
                  program. Please provide the following financial information{" "}
                  <strong>in your local currency</strong>:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={currencies}
                  getOptionLabel={(option) => option.name}
                  onChange={handleCurrencyChange}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <Typography>
                          Local Currency{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      error={state.errors.includes("currency")}
                      helperText={
                        state.errors.includes("currency")
                          ? "Please select your local currency"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography variant="h6">
                  NOTE: this program will make payments in Euro and US Dollar
                  only.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl>
                  <FormLabel>
                    Is your annual income below EUR 22,500? Please include all
                    pensions.
                  </FormLabel>

                  <RadioGroup
                    row
                    name="isIncomeBelow"
                    value={state.isIncomeBelow}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl>
                  <FormLabel>
                    Are your assets below EUR 22,500? Do not include your
                    primary residence or automobile in this calculation.
                  </FormLabel>

                  <RadioGroup
                    row
                    name="isAssetsBelow"
                    value={state.isAssetsBelow}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1">
                  Please upload a copy of your government issued identification,
                  such as a driver's license, passport, or other form of
                  government identification.
                </Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  List of supported files: .jpg, .jpeg, .png, .pdf, .doc, .docx
                </Typography>
              </Grid>

              <Grid
                item
                xs={4}
                sx={{ height: "5em", pt: 0 }}
                className="document files"
              >
                <FormControl fullWidth>
                  <InputLabel id="document">
                    <Typography>
                      Document Type{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="document"
                    fullWidth
                    value={state.document}
                    label={
                      <Typography>
                        Document Type{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    onChange={handleChangeDocument}
                    error={state.errors.includes("document")}
                  >
                    {documents.map((document) => (
                      <MenuItem
                        value={document === "Please select" ? "" : document}
                        key={document}
                      >
                        {document}
                      </MenuItem>
                    ))}
                  </Select>
                  {state.errors.includes("document") ? (
                    <FormHelperText sx={{ color: "#D32F2F" }}>
                      Please select a document type
                    </FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={7} sx={{ height: "5em" }}>
                <TextField
                  fullWidth
                  disabled
                  name="files"
                  value={
                    files.length ? files.map((file) => " " + file.name) : ""
                  }
                  error={state.errors.includes("files")}
                  helperText={
                    state.errors.includes("files") ? (
                      !files.length ? (
                        "Please select a file to attach"
                      ) : (
                        "Unsupported file type"
                      )
                    ) : (
                      <Typography> </Typography>
                    )
                  }
                />
              </Grid>
              <Grid
                item
                xs={1}
                sx={{
                  height: "5em",
                  pt: 0,
                  "& .MuiGrid-root.MuiGrid-item": { pt: 0 },
                }}
              >
                <Button
                  sx={{
                    color: "black",
                    display: files.length ? "block" : "none",
                    padding: 0,
                  }}
                  onClick={() => dispatch(removeFile(0))}
                >
                  <Close />
                </Button>
              </Grid>
              <Grid item xs={4} sx={{ height: "4em" }}></Grid>
              <Grid
                item
                xs={8}
                sx={{
                  padding: 0,
                  justifyContent: "left",
                  display: "flex",
                  height: "4em",
                }}
              >
                <input
                  accept={acceptedExtensions.join(",")}
                  style={{ display: "none", padding: "none" }}
                  id="fileButton"
                  type="file"
                  multiple
                  onChange={handleFileUpload}
                />
                <label htmlFor="fileButton">
                  <Button component="span">Browse</Button>
                </label>
              </Grid>
              {state.document === "Other" ? (
                <Grid item xs={12}>
                  <TextField
                    label={
                      <Typography>
                        Document Type{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    fullWidth
                    name="documentType"
                    value={state.documentType}
                    onChange={handleAlphanumInputChange}
                    error={state.errors.includes("documentType")}
                    helperText={
                      state.errors.includes("documentType")
                        ? "Please enter the document type"
                        : ""
                    }
                  />
                </Grid>
              ) : null}

              <Grid item xs={12} sx={{ padding: 0 }}>
                <FormControl>
                  <FormLabel
                    sx={{
                      color: state.errors.includes("isRecentlyCompensated")
                        ? "#d32f2f"
                        : "black",
                    }}
                  >
                    Have you received Claims Conference compensation within the
                    past two years?
                  </FormLabel>

                  <RadioGroup
                    row
                    name="isRecentlyCompensated"
                    value={state.isRecentlyCompensated}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Collapse
                in={state.isRecentlyCompensated === true}
                sx={{ width: "100%", paddingLeft: 3 }}
              >
                <Grid item xs={12} sm={12}>
                  <TextField
                    label={
                      !state.isRecentlyCompensated ? (
                        <Typography>
                          IBAN/Account Number{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      ) : (
                        <Typography>
                          Last 4 digits of your IBAN/Account number{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      )
                    }
                    fullWidth
                    placeholder={state.isRecentlyCompensated ? "XXXX" : ""}
                    name="ibanNumber"
                    value={state.ibanNumber}
                    onChange={handleAlphanumInputChange}
                    error={state.errors.includes("ibanNumber")}
                    helperText={
                      state.errors.includes("ibanNumber")
                        ? "Please enter your IBAN/Account Number"
                        : ""
                    }
                  />
                </Grid>
              </Collapse>

              <Collapse
                in={state.isRecentlyCompensated === false}
                sx={{ width: "100%", paddingLeft: 3 }}
              >
                <Grid item xs={12}>
                  <TextField
                    label={
                      <Typography>
                        Name of Bank{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    fullWidth
                    name="bankName"
                    value={state.bankName}
                    onChange={handleTextInputChange}
                    error={state.errors.includes("bankName")}
                    helperText={
                      state.errors.includes("bankName")
                        ? "Please enter your bank name"
                        : ""
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label={
                      <Typography>
                        Address of Bank{" "}
                        <Typography color="red" component="span">
                          *
                        </Typography>
                      </Typography>
                    }
                    fullWidth
                    name="bankAddress"
                    value={state.bankAddress}
                    onChange={handleAlphanumInputChange}
                    error={state.errors.includes("bankAddress")}
                    helperText={
                      state.errors.includes("bankAddress")
                        ? "Please enter your bank address"
                        : ""
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl>
                    <FormLabel
                      sx={{
                        color: state.errors.includes("accountType")
                          ? "#d32f2f"
                          : "black",
                      }}
                    >
                      What type of account are you designating?{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </FormLabel>

                    <FormGroup row onChange={handleCheckboxChange}>
                      <FormControlLabel
                        name="accountType"
                        value={"CHECKING/REGULAR"}
                        control={<Checkbox />}
                        label="CHECKING/REGULAR"
                        checked={state.accountType === "CHECKING/REGULAR"}
                      />
                      <FormControlLabel
                        name="accountType"
                        value={"SAVINGS"}
                        control={<Checkbox />}
                        label="SAVINGS"
                        checked={state.accountType === "SAVINGS"}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <FormControl>
                    <FormLabel
                      sx={{
                        color: state.errors.includes("accountCurrency")
                          ? "#d32f2f"
                          : "black",
                      }}
                    >
                      Which currency can your account receive money in?{" "}
                      <Typography color="red" component="span">
                        *
                      </Typography>
                    </FormLabel>

                    <FormGroup row onChange={handleCheckboxChange}>
                      <FormControlLabel
                        name="accountCurrency"
                        value={"EURO"}
                        control={<Checkbox />}
                        label="EURO"
                        checked={state.accountCurrency === "EURO"}
                      />
                      <FormControlLabel
                        name="accountCurrency"
                        value={"USD"}
                        control={<Checkbox />}
                        label="USD"
                        checked={state.accountCurrency === "USD"}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      label={
                        <Typography>
                          IBAN/Account Number{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="ibanNumber"
                      value={state.ibanNumber}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("ibanNumber")}
                      helperText={
                        state.errors.includes("ibanNumber")
                          ? state.ibanNumber
                            ? "IBAN has to be at least 11 digits"
                            : "Please enter your IBAN/Account Number"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label={
                        <Typography>
                          SWIFT Code{" "}
                          <Typography color="red" component="span">
                            *
                          </Typography>
                        </Typography>
                      }
                      fullWidth
                      name="swiftCode"
                      value={state.swiftCode}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("swiftCode")}
                      helperText={
                        state.errors.includes("swiftCode")
                          ? state.swiftCode
                            ? "SWIFT code has to be at least 8 digits"
                            : "Please enter your SWIFT code"
                          : ""
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 2 }}>
                  <Typography fontWeight="bold">
                    You may need an INTERMEDIARY OR CORRESPONDENT BANK to accept
                    wire transfers.
                  </Typography>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={<Typography>Name of Intermediary Bank</Typography>}
                      fullWidth
                      name="intermediaryBankName"
                      value={state.intermediaryBankName}
                      onChange={handleAlphanumInputChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={<Typography>IBAN/Account Number</Typography>}
                      fullWidth
                      name="intermediaryBankNumber"
                      value={state.intermediaryBankNumber}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("intermediaryBankNumber")}
                      helperText={
                        state.errors.includes("intermediaryBankNumber")
                          ? state.intermediaryBankNumber
                            ? "IBAN has to be at least 11 digits"
                            : "Please enter IBAN/Account Number of the Intermediary Bank"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={<Typography>SWIFT Code</Typography>}
                      fullWidth
                      name="intermediaryBankSwiftCode"
                      value={state.intermediaryBankSwiftCode}
                      onChange={handleAlphanumInputChange}
                      error={state.errors.includes("intermediaryBankSwiftCode")}
                      helperText={
                        state.errors.includes("intermediaryBankSwiftCode")
                          ? state.intermediaryBankSwiftCode
                            ? "SWIFT code has to be at least 8 digits"
                            : "Please enter the SWIFT code of the Intermediary Bank"
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </Collapse>

              <Modal
                open={state.isOpen}
                onClose={(event, reason) => {
                  if (reason !== "backdropClick")
                    setState({ ...state, isOpen: false });
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <>
                  <Consent
                    handleCheckboxChange={handleCheckboxChange}
                    isConsent1={!!state.isConsent1}
                    isConsent2={!!state.isConsent2}
                    handleCloseModal={handleCloseModal}
                    submit={submit}
                    disabled={disabled}
                  />
                </>
              </Modal>

              <Grid item xs={12} sm={4}>
                <Button variant="contained" type="submit" fullWidth>
                  CONTINUE
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}

function useKeyDispensor() {
  const dispensor = useRef(0);
  return useCallback(() => dispensor.current++, []);
}
